import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';
import { Box, IconButton, Menu, MenuItem, useTheme } from '@mui/material';

import { AppNS } from '../../../..';
import { getStyles } from './ToolbarMenuStyles';

interface ToolbarMenuProps {
  menuItems: Array<AppNS.ToolbarMenuItem>;
  noFloatingMenu?: boolean;
}

export default function ToolbarMenu(props: ToolbarMenuProps) {
  const { menuItems, noFloatingMenu } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const navigate = useNavigate();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (redirectHref: string) => {
    setAnchorEl(null);
    if (redirectHref) {
      navigate(redirectHref);
    }
  };
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <>
      {noFloatingMenu && (
        <Box sx={styles.menu}>
          {menuItems.map((item: AppNS.ToolbarMenuItem) => (
            <li key={item.id}>
              <NavLink to={item.href}>{item.name}</NavLink>
            </li>
          ))}
        </Box>
      )}

      {!noFloatingMenu && (
        <>
          <Box display={{ xs: 'none', sm: 'none', md: 'block' }}>
            <Box sx={styles.menu}>
              {menuItems.map((item: AppNS.ToolbarMenuItem) => (
                <li key={item.id}>
                  <NavLink to={item.href}>{item.name}</NavLink>
                </li>
              ))}
            </Box>
          </Box>

          <Box display={{ xs: 'block', sm: 'block', md: 'none' }} ml={1}>
            <IconButton aria-label="User Menu" onClick={handleClick}>
              <MenuIcon fontSize="inherit" />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={() => {
                handleClose('');
              }}
            >
              {menuItems.map((item: AppNS.ToolbarMenuItem) => (
                <MenuItem
                  key={item.id}
                  onClick={() => {
                    handleClose(item.href);
                  }}
                >
                  {item.name}
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </>
      )}
    </>
  );
}
